import { Box, Button as ThemeUiButton } from "theme-ui";
import { useDispatch } from "react-redux";

import { displayVideoModal } from "store/app/appSlice";
import * as styles from "./ImageBadges.styles";
import { VideoHoverIcon } from "components/icons";

const ImageBadge = (props) => {
  const dispatch = useDispatch();
  const sx = styles.imageBadge({ backgroundUrl: props.url });

  if (!props?.video?.url) {
    return <Box sx={sx} />;
  }

  const onClick = () => dispatch(displayVideoModal(props));

  return (
    <ThemeUiButton variant="unstyled" onClick={onClick} sx={sx}>
      <VideoHoverIcon />
    </ThemeUiButton>
  );
};

export default function ImageBadges({ imageBadges = [] }) {
  return (
    <Box sx={styles.imageBadges}>
      {imageBadges.map((imageBadge) => (
        <ImageBadge {...imageBadge} key={imageBadge.url} />
      ))}
    </Box>
  );
}
